import { Card } from "antd";
import React from "react";
import CountGraph from "../partials/countGraph";
import SummaryChart from "../partials/summaryChart";
import Income from "../partials/income";
import { useAdmin } from "../../../context/adminContext";
import LastSevenDayInvoice from "components/chart/lastSevenDayInvoice";

const MerchantSummary = () => {
  const { activeMerchantId } = useAdmin();
  return (
    <Card style={{ height: "80vh" }}>
      <CountGraph merchantId={activeMerchantId} />
      <LastSevenDayInvoice merchantId={activeMerchantId} />
      <Income merchantId={activeMerchantId} />
    </Card>
  );
};

export default MerchantSummary;
